export default __webpack_public_path__ + "static/media/info-upload-1.f6f473fd.jpg";